import { BasicErrorService } from './BasicErrorService';
import { BasicValidationService } from './BasicValidationService';
import { AppUtils } from '../../shared/utils/index';

/**
 * Basic error handling class for ves applications
 */
export class VesErrorService<T extends BasicAppDefinition> extends BasicErrorService<T> {

	private readonly validationService: BasicValidationService<VesAppDefinition>;

	public isBlockIndicatorError(jqxhr: JQueryXHR): boolean {
		if (jqxhr?.responseJSON?.Messages) {
			const responseErrors = jqxhr.responseJSON.Messages as AdacResultMessage[];
			return responseErrors.some((errorObj) => errorObj.Id === 120000 && errorObj.Stop === true);
		}
		return false;
	}

	public displayBlockingIndicatorError(jqxhr: JQueryXHR, subject: string): void {
		if (jqxhr?.responseJSON?.Messages) {
			const responseErrors = jqxhr.responseJSON.Messages as AdacResultMessage[];
			const blockingIndicatorError = responseErrors.find((errorObj) => errorObj.Id === 120000);
			if (blockingIndicatorError) {
				const errorMsg = this.getErrorMessage(blockingIndicatorError);
				this.errorDialog(AppUtils.Helper.linkify(errorMsg, subject));
			}
		}
	}

	public isMglSubmitError(jqxhr: JQueryXHR): boolean {
		let isFailed = false;
		if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
			const responseErrors = jqxhr.responseJSON.Messages as any[];

			if (responseErrors.length > 0) {
				responseErrors.forEach((errorObj) => {
					const errorId = errorObj.Id;
					switch (errorId) {
						case 116001:
						case 116000:
							isFailed = true;
							break;

						default:
							isFailed = false;
							break;
					}
				});
			}
		}
		return isFailed;
	}

	public isShowSuccessPageError(jqxhr: JQueryXHR): boolean {
		let continueToSuccessPage = false;
		if (jqxhr && jqxhr.responseJSON && jqxhr.responseJSON.Messages) {
			const responseErrors = jqxhr.responseJSON.Messages as any[];

			if (responseErrors.length > 0) {
				responseErrors.forEach((errorObj) => {
					const errorId = errorObj.Id;
					if (errorId === 189066) {
						continueToSuccessPage = true;
					}
				});
			}
		}
		return continueToSuccessPage;
	}

	/**
	 * Handles the failured submit action
	 *
	 */
	public submitFailed(jqxhr: JQueryXHR, errorThrown: string): boolean {
		let withRenderSucess = false;

		if (jqxhr && jqxhr.status && jqxhr.status.toString().substring(0, 1) === '4') {
			this.onBadRequestError(jqxhr, errorThrown);
		}
		else if (this.isServerValidationError(jqxhr)) {
			this.validationService.showServerValidationErrors(jqxhr);
			this.validationService.triggerValidation();
		}

		if (this.isQualifiedError(jqxhr)) {
			this.handleTechnicalError(jqxhr);
		}
		else {
			this.hideErrorDialog();
			withRenderSucess = true;
		}

		T.Utils.View.stopLoader();
		return withRenderSucess;
	}

	/**
	 * Handles bad requests http errors
	 *
	 */
	private onBadRequestError(jqxhr: JQueryXHR, errorThrown: string): void {
		if (jqxhr && jqxhr.status === 400) {
			this.handleBadRequestErrorWithDialog(jqxhr, errorThrown);
		}
		else {
			this.handleAllOtherHttpErrors(errorThrown);
		}
	}

	public handleDefaultSubmitErrorCallback(
		jqxhr: JQueryXHR,
		applicationName: string,
		trackingCb: () => void,
		storeSepaTokenAndStoreTransactionKeyCb: () => void,
		validationCb: () => void,
		mglSubmitFailedCb: () => void,
		clearSessionCb: () => void,
		renderSuccessTemplateCb: () => void): void {

		trackingCb();
		storeSepaTokenAndStoreTransactionKeyCb();

		if (this.isMglSubmitError(jqxhr)) {
			mglSubmitFailedCb();
		}

		this.handleDefaultErrorResponse(jqxhr, applicationName, validationCb, clearSessionCb, renderSuccessTemplateCb);
	}
}
